import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

import { IAutomationFormConfig, systemSenderOption } from '@employer/app/components/jobs-automation/automation-form-message'
import { IAutomationFormData, automationFormDefaults } from '@employer/app/components/jobs-automation/automation-form.model'
import { EmployerStore } from '@employer/app/modules/customer/employer.store'
import { JobDefaultAutomationService } from '@employer/app/modules/jobs/views/job-automation/job-default-automation.service'
import { JobDefaultAutomationStore } from '@employer/app/modules/jobs/views/job-automation/job-default-automation.store'
import { PermissionStore } from '@engineering11/access-web'
import { E11Logger } from '@engineering11/web-api-error'
import { Observable, map, tap } from 'rxjs'
import { JobAutomationPermissions } from 'shared-lib'
import { IAutomatedQuestionMessageFormData, automatedQuestionMessageFormDefaults } from './auto-question-message.model'
import { JobsPostAutomationCompanySettingsStore } from './jobs-post-automation-company-settings.store'

@Component({
  selector: 'app-automation-settings',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <e11-panel *ngrxLet="canEditMessages$ as canEditMessages">
      <div
        *ngIf="!canEditMessages"
        class="e11-flex e11-items-start e11-gap-2 e11-rounded-md e11-bg-skin-app-bg e11-border e11-border-skin-app-borders e11-px-3 e11-py-2 e11-mb-4"
      >
        <span class="material-symbols-outlined md-18 e11-text-skin-light e11-shrink-0">lock</span>
        <p class="e11-text-sm e11-text-skin-dark e11-mb-0">
          {{ 'Automation messages are a Cnect Plus feature. Upgrade to Cnect Plus to edit your company automation.' | translate }}
        </p>
      </div>

      <job-automation-form
        *ngrxLet="formConfig$ as formConfig"
        [formData]="(formData$ | async) ?? automationFormDefaults | deepCopy"
        [formConfig]="formConfig"
        [canSave]="canEditMessages"
        [saving]="(saving$ | async) ?? false"
        [loading]="(loading$ | async) ?? false"
        (newFormData)="saveAutomation($event)"
      ></job-automation-form>

      <automation-auto-question-form
        *ngrxLet="formConfig$ as formConfig"
        [loading]="(loading$ | async) ?? false"
        [formConfig]="formConfig"
        [formData]="(formData$ | async) ?? automationFormDefaults | deepCopy"
        (valueChanges)="automatedQuestionMessages = $event"
      ></automation-auto-question-form>
    </e11-panel>
  `,
  styles: [],
})
export class JobsPostAutomationCompanySettingsComponent implements OnInit {
  employer$ = this.employerStore.employer$

  automationFormDefaults = automationFormDefaults

  saving$ = this.jobsPostAutomationCompanySettingsStore.saving$
  loading$ = this.jobsPostAutomationCompanySettingsStore.loaded$.pipe(map(l => !l))

  formData$ = this.jobsPostAutomationCompanySettingsStore.formData$
  defaultMessage$ = this.jobDefaultAutomationStore.defaultMessage$.pipe(
    tap(defaultMessage => {
      if (defaultMessage) {
        this.automationFormDefaults = JobDefaultAutomationService.applyDefaultAutomationMessages(defaultMessage, this.automationFormDefaults)
      }
    })
  )

  canEditMessages$ = this.permissionStore.hasPermission(JobAutomationPermissions.EditAutomationMessage)

  formConfig$: Observable<IAutomationFormConfig> = this.canEditMessages$.pipe(
    map(canEditMessages => ({
      senderOptions: [systemSenderOption],
      canEditMessages,
    }))
  )
  automatedQuestionMessages: IAutomatedQuestionMessageFormData = automatedQuestionMessageFormDefaults

  constructor(
    private permissionStore: PermissionStore,
    private employerStore: EmployerStore,
    private jobsPostAutomationCompanySettingsStore: JobsPostAutomationCompanySettingsStore,
    private jobDefaultAutomationStore: JobDefaultAutomationStore,
    private logger: E11Logger
  ) {}

  ngOnInit() {
    this.jobsPostAutomationCompanySettingsStore.onGetAutomation()
  }

  saveAutomation(formData: Partial<IAutomationFormData>) {
    this.logger.log('JobAutomationComponent.saveAutomation', formData)
    if (formData.autoQuestions) {
      formData = { ...formData, autoQuestions: { ...formData.autoQuestions, defaultMessages: this.automatedQuestionMessages } }
    }
    this.jobsPostAutomationCompanySettingsStore.onSaveAutomation(formData)
  }
}
